import { render } from "./JoinDestinationBoard.vue?vue&type=template&id=f7101e0c&scoped=true"
import script from "./JoinDestinationBoard.vue?vue&type=script&lang=js"
export * from "./JoinDestinationBoard.vue?vue&type=script&lang=js"

import "./JoinDestinationBoard.vue?vue&type=style&index=0&id=f7101e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7101e0c"]])

export default __exports__